import React from 'react';
import Spline from '@splinetool/react-spline';
import './App.css';

function App() {
  return (
    <div className="App">
     


      {/* Spline 3D Scene */}
      <div style={{ width: '100%', height: '500px' }}>
        <Spline scene="/scene.splinecode" />
      </div>
    </div>
  );
}

export default App;
